module.exports = __webpack_public_path__ + "img/11n.28f379f7.png";